import type { FaireBrandEntity } from "../../entity_types/brand";

export const catalog_brand_abbott: FaireBrandEntity = {
  token: "catalog_brand_abbott",
  type: "brand",
  name: "Abbott",
  location: "Canada",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
